module.exports = __webpack_public_path__ + "img/logo.5b0bf123.png";